import { CoreInput } from '@/components/Form/InputAntForm';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import React from 'react';
import { useFieldArray } from 'react-hook-form';

interface Props {
  control: any;
  name: string;
  className?: string;
  disabled?: boolean;
}

export const HashParamsForm: React.FC<Props> = (props) => {
  const { control, name, className, disabled } = props;

  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const handleAddParam = () => {
    append({ name: '', value: '' });
  };

  const handleRemoveParam = (index: number) => {
    remove(index);
  };

  return (
    <div className={className}>
      <div className='flex justify-between items-center mb-4'>
        <Typography.Text className='font-medium'>Hash Parameters</Typography.Text>
        <Button
          type='dashed'
          onClick={handleAddParam}
          icon={<PlusOutlined />}
          disabled={disabled}
          size='small'
        >
          Add Parameter
        </Button>
      </div>

      {fields.length === 0 && (
        <div className='text-gray-400 text-center py-4 border border-dashed border-gray-300 rounded'>
          No hash parameters added yet
        </div>
      )}
      {fields.map((field, index) => (
        <div key={field.id} className='border border-gray-200 rounded p-4 mb-4 bg-gray-50'>
          <div className='flex justify-between items-start mb-3'>
            <Typography.Text className='font-medium'>Parameter {index + 1}</Typography.Text>
            <Button
              type='text'
              danger
              size='small'
              icon={<DeleteOutlined />}
              onClick={() => handleRemoveParam(index)}
              disabled={disabled}
            />
          </div>

          <div className='grid grid-cols-2 gap-4'>
            <CoreInput
              control={control}
              name={`${name}.${index}.name`}
              label='Parameter Name'
              placeholder='e.g. refresh'
              className='w-full'
              disabled={disabled}
            />

            <CoreInput
              control={control}
              name={`${name}.${index}.value`}
              label='Parameter Value'
              placeholder='e.g. 60'
              className='w-full'
              disabled={disabled}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
